import { PurchaseEvent } from '@/usecases/event-bus-for-third-party/event'
import { executeWebCustomerConversionTag } from '@/vendor/web-customer-service-tool'
import { convertToGAFormat } from './send-to-ga'

export function sendToWebCustomerTool(event: PurchaseEvent): void {
  const payload = convertToGAFormat(event)

  /**
   * Web接客ツールは（たまたま）、GA（UA）に送信されるのと同じe-commerceデータ型を前提として調整されている。
   */
  executeWebCustomerConversionTag(payload)
}
